import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormInput from '../../../../../library/form/components/FormInput';

const ProdIOORetAddRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn30">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "batchId" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAvail" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <div style={{float:"left"}}> 
                        <FormInput formObject={formObject} className="uiWidth55 uiSpacerH5" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'retQty1', 
                            actionParam: {formulaSource: "RQ1", updateQty : "1", actionType:"updateQty"}}} />
                        <FormInput formObject={formObject} className="uiWidth55" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'retQty2', 
                            actionParam: {formulaSource: "RQ2", updateQty : "1", actionType:"updateQty"} }} />
                    </div>
                </li>
            </ul>
        )
}

export default ProdIOORetAddRow